(() => {
  'use strict';
  const observers = new Set();
  const boundBanners = new WeakSet();
  const boundReviews = new WeakSet();
  const heldProducts = new Set(['9966806434098', '9967712305458']);
  const bannerRules = [
    {
      id: '364679ef-64b0-4c4b-975c-77fd7d636b52',
      before: ['Easy Returns', 'Return with Ease'],
      after: ['7-day replacement support', 'For covered product issues; see replacement terms.'],
    },
    {
      id: 'd10a1706-1513-4120-9c97-a2623217dfa0',
      before: ['3 Year', 'Extended Warranty'],
      after: ['Optional 3-year extended warranty', 'Paid option'],
    },
  ];
  const clean = (node) => node?.textContent.replace(/\s+/g, ' ').trim() || '';

  function updateBanner(banner, rule) {
    banner.querySelectorAll('.icon-block').forEach((block) => {
      const title = block.querySelector('.text-container > .title');
      const subtitle = block.querySelector('.text-container > .subheading');
      if (clean(title) !== rule.before[0] || clean(subtitle) !== rule.before[1]) return;
      title.textContent = rule.after[0];
      subtitle.textContent = rule.after[1];
      title.style.lineHeight = '1.3';
      subtitle.style.lineHeight = '1.35';
      block.setAttribute('data-vukar-trust-label', 'updated');
    });
  }

  function bindBanner(banner, rule) {
    updateBanner(banner, rule);
    if (boundBanners.has(banner)) return;
    boundBanners.add(banner);
    const observer = new MutationObserver(() => updateBanner(banner, rule));
    observer.observe(banner, { subtree: true, childList: true, characterData: true });
    observers.add(observer);
  }

  function updateStoreReview(widget) {
    widget.querySelectorAll('.jdgm-all-reviews-text__text').forEach((text) => {
      const match = clean(text).match(/^Customers rate us ([0-5](?:[.,]\d+)?)\/5 based on ([\d,\u00a0 ]+) (reviews?)\.$/);
      if (!match) return;
      text.textContent = `Store reviews on Judge.me · ${match[1]}/5 · ${match[2]} ${match[3]}`;
      text.setAttribute('data-vukar-review-source', 'store-aggregate');
    });
  }

  function bindStoreReview(widget) {
    updateStoreReview(widget);
    if (boundReviews.has(widget)) return;
    boundReviews.add(widget);
    const observer = new MutationObserver(() => updateStoreReview(widget));
    observer.observe(widget, { subtree: true, childList: true, characterData: true });
    observers.add(observer);
  }

  function initialize(scope = document) {
    scope.querySelectorAll('script[data-vukar-product-trust-labels]').forEach((entry) => {
      if (entry.dataset.bound === 'true') return;
      let config;
      try { config = JSON.parse(entry.textContent); } catch { return; }
      if (config.locale !== 'en' || heldProducts.has(String(config.productId))) return;
      const root = document.getElementById(config.rootId);
      if (!root || root.tagName.toLowerCase() !== 'product-info') return;
      if (String(root.dataset.productId) !== String(config.productId)) return;
      if (!/^en(?:-|$)/i.test(document.documentElement.lang)) return;
      entry.dataset.bound = 'true';
      bannerRules.forEach((rule) => {
        const selector = `[data-banner][data-type="product-page"][data-id="${rule.id}"]`;
        document.querySelectorAll(selector).forEach((banner) => bindBanner(banner, rule));
      });
      root.querySelectorAll('.jdgm-all-reviews-text').forEach(bindStoreReview);
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('pagehide', (event) => {
    if (event.persisted) return;
    observers.forEach((observer) => observer.disconnect());
    observers.clear();
  });
})();
